

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Rahita.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import axios from 'axios';
import { Link } from 'react-router-dom';
import city from '../../../city.json'


const Rahita = () => {

  const panchakaRahitaTooltips = {
  "Raja - Bad": "Raja represents challenging or inauspicious time — avoid important tasks during this period.",
  "Shubha - Good": "Shubha means auspicious or favorable time — ideal for starting new ventures or ceremonies.",
  "Chora - Evil": "Chora indicates negative or harmful time — not suitable for important actions.",
  "Roga - Disease": "Roga signifies illness or health-related difficulties — avoid stressful or risky activities.",
  "Mrityu - Danger": "Mrityu means danger or death-related energy — highly inauspicious, avoid all important work.",
  "Agni - Risk": "Agni denotes risk or fire-related challenges — be cautious and avoid conflicts.",
};


  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
 
//   const [nightMuhurta, setNightMuhurta] = useState([]);
  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"

   const [panchaka, setPanchaka] = useState(null);


     // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
  const formattedDate = currentDate.toISOString().split("T")[0];
      if (!location || location.trim() === '') return;
      try {
        const res = await axios.get(`https://core-c343.onrender.com/api/panchaka?date=${formattedDate}&location=${encodeURIComponent(location)}`);
        setPanchaka(res.data.panchakaRahita);
      } catch (err) {
        console.error("Error fetching Panchaka:", err);
      }
    };

    fetchData();
  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

const formatTime = (time, mode) => {
  if (!time || typeof time !== 'string') return "N/A";

  const [start, end] = time.split(" to ");

  const parseTime = (t) => {
    if (!t) return "N/A";
    const [hourMin, ampm] = t.trim().split(' ');
    let [hour, minute] = hourMin.split(':').map(Number);
    const isPM = ampm?.toLowerCase() === 'pm';

    if (mode === '12') {
      const suffix = isPM ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`;
    }

    if (mode === '24') {
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    if (mode === '24Plus') {
      if (isPM && hour < 12) hour += 12;
      if (!isPM && hour === 12) hour = 0;
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    return t;
  };

  return `${parseTime(start)} to ${parseTime(end)}`;
};

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

const [selectedSegment, setSelectedSegment] = useState(null);


  const getCurrentSegment = () => {
  if (!panchaka?.segments) return null;

  const now = new Date(); // current time in user's system
  const baseDate = new Date(currentDate.toISOString().split('T')[0]); // strip time

  const toDate = (timeStr) => {
    if (!timeStr) return null;
    let [timePart, suffix] = timeStr.trim().split(' ');
    if (!suffix) suffix = 'AM';
    let [h, m] = timePart.split(':').map(Number);
    if (suffix.toLowerCase() === 'pm' && h < 12) h += 12;
    if (suffix.toLowerCase() === 'am' && h === 12) h = 0;

    const date = new Date(baseDate);
    date.setHours(h, m, 0, 0);

    // Handle rollover after midnight
    if (suffix.toLowerCase().includes('am') && now.getHours() > 12) {
      date.setDate(date.getDate() + 1);
    }

    return date;
  };

  return panchaka.segments.find((item) => {
    const start = toDate(item.start);
    const end = toDate(item.end);
    return now >= start && now <= end;
  });
};

const currentSegment = getCurrentSegment();

  return (
    <div className="Rahita-container">
      <InnerNav />
      <div className="Rahita-content">
        <Zodiac />
        <div className="Rahita-details">
                <div className="title">Pachaka Rahita Muhurat Table</div>
                {/* <div className="sub">Running Do Ghati Muhurat</div> */}
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                 {currentSegment ? (
                    <div className="right">
                      <h3>Currently Active Segment:</h3>
                      <div><p>{currentSegment.type}</p></div>
                      <div><p>{formatTime(`${currentSegment.start} to ${currentSegment.end}`, timeFormat)}</p></div>
                    </div>
                  ):(
                    <p>no data available</p>
                  )}

                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

<div className="muhurta-section">
  {!selectedSegment ? (
    /* ========= LIST VIEW ========= */
    <>
      <div className="muhurta-header">
        <div className="muhurta-date">
          {readableDate}, {weekDay}
        </div>
      </div>

      <div className="muhurta-columns day">
        <div className="muhurta-column full">
          {panchaka?.segments?.map((item, idx) => {
            const goodTypes = [
              "Good", "Subha", "Auspicious", "Safe", "Shubha"
            ];

            const status = goodTypes.some(word =>
              item.type.toLowerCase().includes(word.toLowerCase())
            )
              ? "good"
              : "bad";

            return (
              <div
                key={idx}
                className={`muhurta-card ${
                  status === 'good' ? 'green' : 'red'
                } clickable`}
                onClick={() => setSelectedSegment(item)}
              >
                <div className="title">{item.type}</div>

                <div className="time">
                  {formatTime(`${item.start} to ${item.end}`, timeFormat)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  ) : (
    /* ========= DETAIL VIEW ========= */
    <div className="rahita-detail-page">
      <button
        type="button"
        className="back-btn"
        onClick={() => setSelectedSegment(null)}
      >
        ← Back
      </button>

      <h2>{selectedSegment.type}</h2>

      <p>
        <strong>Time:</strong>{" "}
        {formatTime(
          `${selectedSegment.start} to ${selectedSegment.end}`,
          timeFormat
        )}
      </p>

      <p className="description">
        {panchakaRahitaTooltips[selectedSegment.type]}
      </p>
    </div>
  )}
</div>

            </div>

            <section className="rahita-wrapper">
      <h1 className="rahita-title">What is Panchaka Rahita Muhurat?</h1>
      <div className="rahita-texts">
        <p>
          Panchaka Rahita Muhurat is popular in Telugu speaking people in Andhra Pradesh and Telangana. Panchaka Rahita Muhurtha is used to avoid inauspicious timings. Panchaka Rahita considers Tithi (Lunar day), Vara (weekday), Nakshatra and 
          
          <Link to="/muhurat/lagna-table" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
           Udaya Lagna
          </Link>
           to divide the whole day including night into auspicious and inauspicious time windows. It is believed that all auspicious activities including Marriage, Griha Pravesham and Akshara Abhyasam should be performed during Panchaka Rahitam Muhurtham.
        </p>

        <h2>Why it is named Panchaka Rahita Muhurat?</h2>
        <p>
          Mrityu, Agni, Raja, Chora and Roga are collectively called as 'Panchaka'. Rahita Means 'without'. Muhurat means 'auspicious moment' or 'auspicious time period'. Muhurat is also pronounced and spelt as Muhurta, Muhurtha, Muhurtam or Muhurtham.
        </p>
        <p>
          So Muhurat or Muhurtha without Panchaka is known as Panchaka Rahita Muhurtha. Panchaka Rahita Muhurtha literally means 'auspicious moment without inauspicious Panchaka'.
        </p>

        <h2>Inauspicious timings</h2>
        <p>
          Mrityu, Agni, Raja, Chora and Roga are five inauspicious timings. These five inauspicious time periods should be avoided. Rest time periods are good to start auspicious activities.
        </p>
        <p>
          Mrityu Panchakam indicates danger and hazard. Agni Panchakam indicates risk from fire. Raja Panchakam indicates bad results. Chora Panchakam indicates evil and fraudulent happenings. Roga Panchakam indicats illness and disease.
        </p>
      </div>
    </section>
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Rahita;
